import ScalarIconXCircle_vue_vue_type_script_setup_true_lang_default from "./ScalarIconXCircle.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconXCircle.vue
var ScalarIconXCircle_default = ScalarIconXCircle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconXCircle_default as default };

//# sourceMappingURL=ScalarIconXCircle.js.map